export default function Oferta() {
  return (
    <div>
      <div className="main_block_login">
        <div className={"ofeta_block"}>
          <div
            style={{
              textAlign: "center",
              color: "white",
              fontWeight: "bolder",
              fontSize: "18px",
            }}
          >
            Публичная оферта на оказание услуг
          </div>
          <ul>
            <ol>
              1. Общие положения
              <div>
                Настоящий документ является официальным предложением (публичной
                офертой) Самозанятого Резник Виктора Вячеславовича, ИНН
                772880923142, далее именуемого «Исполнитель», заключить договор
                на оказание услуг на условиях, изложенных ниже.
              </div>
            </ol>
            <ol>
              2. Термины и определения
              <div>
                Ключ доступа — уникальный цифровой код, предоставляющий доступ к
                функционалу Сайта Аккаунт — учетная запись Пользователя на Сайте
                Платежный провайдер — ЮKassa (сервис Яндекс.Касса) Сайт —
                https://club-lab.ru/
              </div>
            </ol>
            <ol>
              3. Предмет договора
              <div>
                Исполнитель предоставляет Пользователю ключи доступа к
                функционалу Сайта, а Пользователь обязуется оплатить услуги в
                порядке и на условиях настоящей оферты.
              </div>
            </ol>
            <ol>
              4. Порядок акцепта оферты
              <div>
                Акцептом (принятием) настоящей оферты считается: Осуществление
                оплаты через платежную систему ЮKassa Заполнение регистрационной
                формы Нажатие кнопки «Купить», «Оплатить» или аналогичной
              </div>
            </ol>
            <ol>
              5. Стоимость и порядок оплаты
              <div>
                5.1. Стоимость услуг указана на Сайте в рублях РФ 5.2. Оплата
                осуществляется через платежного провайдера ЮKassa (ООО «НКО
                «Яндекс.Деньги») 5.3. Исполнитель применяет налог на
                профессиональный доход (НПД) по ставке 4% или 6% 5.4. Момент
                оплаты считается с момента получения подтверждения от платежной
                системы 5.5. Пользователь соглашается с правилами и тарифами
                платежного провайдера ЮKassa
              </div>
            </ol>
            <ol>
              6. Порядок оказания услуг
              <div>
                6.1. После успешного подтверждения оплаты от ЮKassa ключ доступа
                направляется на email Пользователя 6.2. Доступ к функционалу
                предоставляется на срок, указанный в описании услуги 6.3.
                Исполнитель обязуется обеспечить работоспособность Сайта в
                течение 95% времени
              </div>
            </ol>
            <ol>
              7. Возврат средств
              <div>
                7.1. Возврат средств осуществляется через платежную систему
                ЮKassa в соответствии с ее правилами 7.2. Возврат возможен в
                случае: Невозможности оказать услугу по вине Исполнителя
                Технической ошибки при проведении платежа 7.3. Цифровые товары
                надлежащего качества возврату не подлежат 7.4. Запрос на возврат
                направляется на email: support@club-lab.ru
              </div>
            </ol>
            <ol>
              8. Ответственность сторон
              <div>
                8.1. Исполнитель не несет ответственности за: Сбои в работе
                платежной системы ЮKassa Ошибки при вводе платежных данных
                Пользователем Действия банков и платежных систем
              </div>
            </ol>
            <ol>
              9. Интеллектуальная собственность Все права на программное
              обеспечение, дизайн и контент Сайта принадлежат Исполнителю.
            </ol>
            <ol>
              10. Персональные данные
              <div>
                10.1. Исполнитель обрабатывает персональные данные в
                соответствии с ФЗ-152 10.2. Политика конфиденциальности
                размещена по адресу:{" "}
                <a
                  href="https://club-lab.ru/politic-confidencial"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://club-lab.ru/politic-confidencial
                </a>
                10.3. При оплате через ЮKassa обработка платежных данных
                осуществляется в соответствии с политикой конфиденциальности
                платежного провайдера
              </div>
            </ol>
            <ol>
              11. Реквизиты Исполнителя
              <div>
                Самозанятый: [Ваше ФИО] ИНН: [Ваш ИНН] Номер свидетельства:
                [номер свидетельства] Дата постановки на учет: [дата]
                Электронная почта: [ваш email] Телефон: [ваш телефон] Платежный
                провайдер: ООО «НКО «Яндекс.Деньги» ИНН 7750009840 ОГРН
                1147746000613 Адрес: 121099, г. Москва, пер. Новинский, д. 8,
                пом.1
              </div>
            </ol>
            <ol>
              12. Заключительные положения
              <div>
                12.1. Настоящая оферта регулируется законодательством РФ 12.2.
                Все споры разрешаются путем переговоров, а при недостижении
                согласия - в суде по месту регистрации Исполнителя 12.3.
                Исполнитель оставляет за собой право изменять условия оферты с
                публикацией изменений на Сайте
              </div>
            </ol>
          </ul>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}
